var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileMessage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 0H2.99998C1.34296 0 0 1.34299 0 3.00004V19.0004C0 20.6575 1.34296 22.0005 2.99998 22.0005H6.55015L6.0064 26.8908C5.94547 27.4398 6.34156 27.9338 6.89058 27.9947C7.17417 28.0258 7.45717 27.9349 7.66928 27.7439L14.0513 22.0011H25C26.657 22.0011 28 20.6581 28 19.001V3.00004C28 1.34299 26.6565 0 25 0ZM25.9996 19.0004C25.9996 19.553 25.552 20.0007 24.9994 20.0007H13.6669C13.4196 20.0007 13.1817 20.0921 12.9978 20.2579L8.28393 24.5007L8.66068 21.1116C8.7222 20.5626 8.3267 20.068 7.77768 20.0065C7.74077 20.0024 7.70385 20.0001 7.66635 20.0001H2.99998C2.44744 20.0001 1.99979 19.5524 1.99979 18.9999V3.00004C1.99979 2.44749 2.44744 1.99983 2.99998 1.99983H25C25.5526 1.99983 26.0002 2.44749 26.0002 3.00004L25.9996 19.0004Z",
    fill: "#499FD7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMessage);
export default __webpack_public_path__ + "static/media/mobile-message.32848d11.svg";
export { ForwardRef as ReactComponent };